<template>
  <div class="flex-content">
    <div class="card">
      <form-wizard stepSize="sm" ref="formWizard" color="#007ACE" @on-complete="onComplete">
        <tab-content title="Mercado" :before-change="marketRolValidation">
          <signup-market-rol ref="signUpMarketRol"/>
        </tab-content>
        <tab-content title="Datos de la Entidad" :before-change="checkOrganizationValidations">
          <signup-organization-data ref="signUpOrganizationData" @ready='$refs.formWizard.nextTab()'/>
        </tab-content>
        <tab-content title="Datos del Administrador" :before-change="checkAdminDataValidations"> <!-- -->
          <signup-admin-data ref="signUpAdminData" @ready='$refs.formWizard.nextTab()'/>
        </tab-content>
        <tab-content title="Establecimientos Compradores" v-if="market.buy" :before-change="BuyerEstablishmentsValidation">
          <signup-buyer-establishments v-if="!completed" ref="signUpBuyerEstablishments" @ready='$refs.formWizard.nextTab()'/>
        </tab-content>
        <tab-content title="Establecimientos Vendedores" v-if="market.sell" :before-change="SellerEstablishmentsValidation">
          <signup-seller-establishments v-if="!completed" ref="signUpSellerEstablishments" @ready='$refs.formWizard.nextTab()'/>
        </tab-content>
        <template slot="footer" slot-scope="props">
          <div v-if="props.isLastStep" class="terms-and-conditions">
            <input type="checkbox" id="agreeTermsAndConditions" class="we-check" v-model="agreeTermsAndConditions">
            <label data-test="input-checkbox" for="agreeTermsAndConditions">He leído y acepto los <a href="https://rosporc.bcr.com.ar/documentos/TerminosyCondiciones-Rosporc.pdf" target="_blank" rel="noopener noreferrer">términos y condiciones</a></label>
            <span v-if="(!!shouldAgreeTermsErrorMsg && !agreeTermsAndConditions)" class="validation-error-message">{{ shouldAgreeTermsErrorMsg }}</span>
          </div>
          <div class="wizard-footer-left">
            <vs-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" type="filled" color="#e0e0e0">Volver</vs-button>
          </div>
          <div class="wizard-footer-right">
            <vs-button data-test="continue-btn" @click.native="props.nextTab()" color="success" type="filled">{{ props.isLastStep ? 'Finalizar' : 'Continuar' }}</vs-button>
          </div>
        </template>
      </form-wizard>
      <div class='markets'> <!-- TODO: Remove class markets. -->
        <p class="validation-error-message" style='position: initial !important;' :key='index' v-for='(orgErr, index) in createOrgErrors'>{{ $t(`organization.registration.${orgErr}`) }}{{ (index < createOrgErrors.length - 1) ? ',' : '.' }} </p>
        <p class="validation-error-message" style='position: initial !important;' :key='index' v-for='(userErr, index) in createUserErrors'>{{ userErr.message }}</p>
      </div>
      <signup-sent-message v-if="completed"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import SignUp from '@/lib/bcrSignUp'
import { mapState, mapMutations } from 'vuex'
// mapActions mapGetters
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import FormData from 'form-data'

Vue.use(SignUp)

const signUpMutation = gql`
  mutation signUp($createOrganization: OrganizationCreation!, $createUser: UserCreation!, $createEstablishments: [EstablishmentCreation!]!) {
    signUp(createOrganization: $createOrganization, createUser: $createUser, createEstablishments: $createEstablishments) {
      success
      organization {
        organization {
          id
        }
      }
    }
  }
`

export default {
  name: 'RegistrationForm',
  components: {
    FormWizard,
    TabContent
  },
  data () {
    return {
      completed: false,
      createOrgErrors: [],
      createUserErrors: [],
      agreeTermsAndConditions: false,
      shouldAgreeTermsErrorMsg: ''
    }
  },
  computed: mapState({
    market: state => state.SignUp.market,
    org: state => state.SignUp.organization,
    admin: state => state.SignUp.admin,
    establishments: state => state.SignUp.establishments,
    roles: state => state.SignUp.roles
  }),
  methods: {
    ...mapMutations('SignUp', [
      'setOrganization',
      'setAdmin'
    ]),
    SellerEstablishmentsValidation () {
      return this.$refs.signUpSellerEstablishments.readyForNext()
    },
    BuyerEstablishmentsValidation () {
      return this.$refs.signUpBuyerEstablishments.readyForNext()
    },
    marketRolValidation () {
      return this.$refs.signUpMarketRol.readyForNext()
    },
    checkOrganizationValidations () {
      return this.$refs.signUpOrganizationData.formWithoutErrors()
    },
    checkAdminDataValidations () {
      return this.$refs.signUpAdminData.formWithoutErrors()
    },
    submitSignUp () {
      var dniOrPass = { dni: this.admin.dni }
      if (!this.admin.dni) { dniOrPass = { passport: this.admin.passport } }

      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(signUpMutation),
        variables: {
          createOrganization: {
            roleIds: this.$store.getters['SignUp/roleIdsSelected'],
            comments: this.org.comments,
            iibbSituation: this.org.iibbSituation,
            cuit: this.org.cuit,
            businessName: this.org.businessName,
            zipcode: this.org.zipcode,
            incomeTaxSituation: this.org.incomeTaxSituation,
            ivaSituation: this.org.ivaSituation,
            commercialAddress: this.org.commercialAddress,
            email: this.org.email,
            phone: this.org.phone,
            country: this.org.country,
            city: this.org.city,
            state: this.org.state,
            productionMothers: Number(this.org.productionMothers),
            ruca: this.org.ruca,
            slaughterQuantityPerMonth: Number(this.org.slaughterQuantityPerMonth),
            notificationEmails: [this.org.notificationEmails]
          },
          createUser: Object.assign({
            lastname: this.admin.lastname,
            firstname: this.admin.firstname,
            email: this.admin.email,
            password: this.admin.password,
            phone: this.admin.phone,
            cuil: this.admin.cuil,
            organizationId: JSON.stringify(this.org.id)
          }, dniOrPass),
          createEstablishments: this.establishments.buyer.map( buyEst => {
            return {
              number: buyEst.number,
              ruca: buyEst.ruca,
              activity: buyEst.activity,
              roleIds: [this.roles.find(rol => rol.name === 'buyer').id],
              name: buyEst.name,
              city: buyEst.city,
              state: buyEst.state,
              zipcode: buyEst.zipcode,
              active: buyEst.status,
              sanitaryProfile: 'Example'
            }
          }).concat( this.establishments.seller.map( sellEst => {
            return {
              renspa: sellEst.renspa,
              cuig: sellEst.cuig,
              roleIds: [this.roles.find(rol => rol.name === 'seller').id],
              name: sellEst.name,
              city: sellEst.city,
              state: sellEst.state,
              zipcode: sellEst.zipcode,
              active: sellEst.status,
              sanitaryProfile: 'Example'
            }
          }))
        }
      }).then( res => {
        if (!res.data.errors) {
          this.postOrgLogo(res.data.data.signUp.organization.organization.id)
          this.createOrgErrors = []
          this.completed = true
          document.querySelector('.wizard-nav.wizard-nav-pills .active').classList.add('confirmed')
          document.querySelector('.wizard-nav.wizard-nav-pills .active').classList.remove('active')
          document.querySelector('.vue-form-wizard .wizard-card-footer').style.display = 'none'
        } else {
          this.createOrgErrors = ['Hubo un problema, revise los datos y vuelva a intentarlo.']
        }
      }).catch( err => {})
    },
    async onComplete () {
      if (this.agreeTermsAndConditions) {
        this.shouldAgreeTermsErrorMsg = ''
        this.submitSignUp()
      } else {
        this.shouldAgreeTermsErrorMsg = 'Debe aceptar los términos y condiciones para continuar'
      }
    },
    postOrgLogo (orgId) {
      if (this.org.logo.size) {
        let data = new FormData()
        let url = process.env.VUE_APP_RAILS_PATH
        data.append('file', this.org.logo)
        axios.post(`${url}/organizations/upload_image/${orgId}`, data, {
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${data._boundary}`
          }
        }).then(res => {
          console.log('Logo updated')
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style>
  .flex-content {
    flex-grow: 1;
  }
</style>
